import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import styled from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { EnvironmentService } from '../../services/environment/EnvironmentService';
import { PluginApiService } from '../../services/pluginapi/PluginApiService';
import { PluginListService } from '../../services/pluginlist/PluginListService';
import { formPluginUrl } from '../../utils/routes';
import { hiddenFrameClassName } from './hiddenStyles';
export function PluginButtonTray({ slotId, hidden = false, className, }) {
    const pluginApiService = PluginApiService.getNotificationInterface();
    const pluginOutputSlots = PluginListService.getOutput().useSlots();
    const isMobile = EnvironmentService.getOutput().useIsMobile();
    const { myRole } = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const currentSlotFrames = pluginOutputSlots[slotId];
    // Create a stable map of ref callbacks to prevent unnecessary re-renders
    const iframeRefCallbacks = useMemo(() => {
        const callbacks = {};
        // TODO: Modify the output to work with this to optimize react redraws
        Object.keys(currentSlotFrames).forEach((keyWithinSlot) => {
            callbacks[keyWithinSlot] = (iframe) => {
                if (iframe !== null) {
                    pluginApiService.notifyIframeMounted(slotId, keyWithinSlot, currentSlotFrames[keyWithinSlot], iframe);
                }
            };
        });
        return callbacks;
    }, [pluginApiService, slotId, currentSlotFrames]);
    const filteredFrameKeys = useMemo(() => {
        return Object.keys(currentSlotFrames).filter((keyWithinSlot) => {
            const frame = currentSlotFrames[keyWithinSlot];
            if (frame.loadOnlyAtRole && frame.loadOnlyAtRole !== myRole) {
                return false;
            }
            if (frame.loadOnlyOnDeviceType &&
                frame.loadOnlyOnDeviceType !== (isMobile ? 'mobile' : 'desktop')) {
                return false;
            }
            return true;
        });
    }, [currentSlotFrames, myRole, isMobile]);
    return (filteredFrameKeys.length > 0 && (_jsx(PluginButtonTrayRoot, { className: `${hidden ? hiddenFrameClassName : ''} ${className ?? ''}`.trim(), children: filteredFrameKeys.map((keyWithinSlot) => {
            const frame = currentSlotFrames[keyWithinSlot];
            return (_jsx(ButtonContent, { title: `${frame.id} ${keyWithinSlot}`, src: formPluginUrl(frame.pluginId, frame.urlPath), ref: iframeRefCallbacks[keyWithinSlot] }, keyWithinSlot));
        }) })));
}
const PluginButtonTrayRoot = styled.div `
    position: absolute;
    top: 1rem;
    left: 1rem;
    display: flex;
    flex-wrap: wrap;
    z-index: 100;
    border: 0;
    padding: 0.5rem;
    border-radius: var(--tv-ui-border-radius-2);
    background: #8080804d;
    backdrop-filter: blur(10px);

    & > * {
        pointer-events: all;
    }
`;
const ButtonContent = styled.iframe `
    width: 2.75rem;
    aspect-ratio: 1 / 1;
    pointer-events: auto;
    z-index: 101;
    margin: 0.125rem;
    align-self: flex-start;
    border: 0;
    padding: 0;
    display: block;
    border-radius: 100%;
    mix-blend-mode: normal;

    > * {
        pointer-events: all;
    }
`;
export const MobilePluginButtonTray = styled(PluginButtonTray) `
    position: static;
    top: auto;
    left: auto;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 0.75rem;
    background: transparent;
    padding: 0;
    backdrop-filter: none;

    iframe {
        margin: 0;
        backdrop-filter: blur(10px);
        border-radius: var(--tv-ui-border-radius-2);
    }
`;
